import Block from './Block'
import Modal from "../modal";
import HTML from '../html'
import {validateInput} from "../utils";

export default class Auction extends Block {

    constructor(root) {
        super(root)

        this.buttons = {
            makeBid: this.root.find('.-openPopup'),
            showBids: this.root.find('.-openBids'),
        }
        this.mainImage = this.root.find('.-images .main')
        this.images = this.root.find('.-images-set img')
        this.form = new Modal()
        this.bidList = new Modal()

        this.images.each((index, image) => {
            $(image).on('click', event => {
                this.mainImage.attr('src', $(image).data('full-src'))
            })
        })

        let svgIcon = `<svg width="63" height="133" viewBox="0 0 63 133" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M23.7242 0H0V133H23.7242C26.1216 133 28.3243 131.68 29.4553 129.567L61.5604 69.5666C62.5855 67.6507 62.5855 65.3493 61.5604 63.4334L29.4554 3.43338C28.3243 1.3196 26.1216 0 23.7242 0Z"/>
                        </svg>`

        let bidListHTML =
            HTML('div')
                .classes('cform')
                .append(
                    HTML('h2')
                        .classes('cform__header')
                        .content('Budhistorik'),
                    HTML('div')
                        .classes('cform__property-title')
                        .append(
                            HTML('h3')
                                .content(this.buttons.makeBid.data('title')),
                            HTML('span')
                                .classes('icon')
                                .content(svgIcon)
                        ),
                    this.root.find('.-bids-content').html(),
                )
                .render()

        let formHTML =
            HTML('form')
                .classes('cform')
                .on('submit', (event, form) => {
                    event.preventDefault()
                    this.send(event, form)
                })
                .append(
                    HTML('div')
                        .classes('cform__wrapper')
                        .append(
                            HTML('h2')
                                .classes('cform__header')
                                .content('Lägga bud'),
                            HTML('div')
                                .classes('cform__property-title')
                                .append(
                                    HTML('h3')
                                        .content(this.buttons.makeBid.data('title')),
                                    HTML('span')
                                        .classes('icon')
                                        .content(svgIcon)
                                ),
                            HTML('div')
                                .classes('trow')
                                .append(
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('Förnamn*'),
                                            HTML('input').attr({
                                                'data-validation': 'text',
                                                type: 'text',
                                                name: 'firstname',
                                            })),
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('Efternamn*'),
                                            HTML('input').attr({
                                                'data-validation': 'text',
                                                type: 'text',
                                                name: 'lastname',
                                            })),
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('Telefon*'),
                                            HTML('input').attr({
                                                'data-validation': 'phone',
                                                type: 'text',
                                                name: 'phone',
                                            })),
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('E-Post*'),
                                            HTML('input').attr({
                                                'data-validation': 'email',
                                                type: 'email',
                                                name: 'email',
                                            })),
                                    HTML('div')
                                        .classes('tcell')
                                        .append(
                                            HTML('label')
                                                .content('Bud*'),
                                            HTML('input').attr({
                                                'data-min': this.buttons.makeBid.data('highest-bid'),
                                                type: 'text',
                                                name: 'bid',
                                            })),
                                ),
                            HTML('label')
                                .classes('cform__checkbox')
                                .on('click', (event, element) => {
                                    if (element.firstChild.checked) {
                                        $(element).parents('form').find('.cform__submit').addClass('legit')
                                        $(element).addClass('selected')
                                    } else {
                                        $(element).parents('form').find('.cform__submit').removeClass('legit')
                                        $(element).removeClass('selected')
                                    }
                                })
                                .append(HTML('span').content('Jag godkänner '))
                                .prepend(
                                    HTML('input')
                                        .attr({
                                            type: 'checkbox',
                                            name: 'policy_accepted',
                                            value: 'accept',
                                        }),
                                )
                                .append(
                                    HTML('a')
                                        .attr({
                                            href: 'https://www.credentia.se/uploads/2018/05/dataskyddspolicy_credentia.pdf',
                                            target: '_blank',
                                        })
                                        .content('dataskyddspolicy enligt GDPR'),
                                ),
                        ),
                    HTML('button')
                        .classes('cform__submit')
                        .attr({ type: 'submit' })
                        .content('Lägg bud'),
                )
                .render()

        this.form.defineContent(formHTML)
        this.bidList.defineContent(bidListHTML)

        this.buttons.makeBid.on('click', event => {
            this.form.show()
        })

        this.buttons.showBids.on('click', event => {
            this.bidList.show()
        })

    }

    send(submitEvent, form) {
        var valid = [true]
        var f = form.elements
        for (let i = 0, input; input = f[i++];) {
            if (input.dataset.validation || input.hasAttribute('required')) {
                valid.push(validateInput(input, input.dataset.validation))
            }

            if (input.dataset.min) {
                valid.push(validateInput(input, 'min'))
            }
        }

        var validity = valid.reduce((res, status) => !res ? res : status)

        if (!validity) {
            return validity
        }

        var wait = new Modal()
        wait.defineContent(
            HTML('h1').content('Vi skickar ditt meddelande. Vänta lite…'),
            HTML('div').classes('generic-preloader').append(
                HTML('i').classes('fa fa-spinner'),
            ),
        )
        wait.on('hide:end', () => {
            wait.destroy()
        })
        this.form.hide()
        wait.show()

        $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'makeBid',
                form: $(submitEvent.target).serialize(),
                wpid: this.buttons.makeBid.data('wpid'),
            },
            success: response => {
                var thanks = new Modal()
                thanks.defineContent(
                    HTML('h1').content('Ditt meddelande har skickats.'),
                    HTML('h2').content('Du lade ett bud'),
                )
                thanks.on('show:end', () => {
                    setTimeout(() => {
                        thanks.hide();
                        window.location.reload();
                    }, 2400)
                })
                thanks.on('hide:end', () => {
                    thanks.destroy()
                })
                wait.hide()
                thanks.show()
            },
            error: function(jqXHR, code, message) {
                console.log(message);
            },
        })
    }
}
